// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ODtdFpqF7s3KdNzclvaP{color:#6c757d}.yOa1c0gjW5jzTYTXGJoW{font-weight:normal;font-size:15px;color:#333;margin-bottom:8px}`, "",{"version":3,"sources":["webpack://./src/pages/ManageSamListings/pages/ManageSamListings/components/SingleManage/components/ActionBlock/styles.module.sass"],"names":[],"mappings":"AAAA,sBACE,aAAA,CACF,sBACE,kBAAA,CACA,cAAA,CACA,UAAA,CACA,iBAAA","sourcesContent":[".earnedText\n  color: #6c757d\n.heading\n  font-weight: normal\n  font-size: 15px\n  color: #333\n  margin-bottom: 8px\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"earnedText": `ODtdFpqF7s3KdNzclvaP`,
	"heading": `yOa1c0gjW5jzTYTXGJoW`
};
export default ___CSS_LOADER_EXPORT___;
